import { ReactElement } from 'react'
import styles from './WebContactScreen.module.scss'
import { DesktopBodyLarge, DesktopHeadlineLarge } from '../../Typography'
import { ContactForm } from '../../components/contact-form/ContactForm'

export const WebContactScreen = (): ReactElement => {
  return (
    <div className={styles.container}>
      <div className={styles.wideColumn}>
        <DesktopHeadlineLarge>Kontakt</DesktopHeadlineLarge>
        <div className={styles.tightColumn}>
          <DesktopBodyLarge>
            Du hast Fragen oder Anregungen rund ums Thema FIGHTBACK-WRESTLING?
          </DesktopBodyLarge>
          <DesktopBodyLarge>
            Du hast Feedback zur Website, oder zu FIGHTBACK-WRESTLING allgemein?
          </DesktopBodyLarge>
          <DesktopBodyLarge>
            Du möchtest selbst Wrestler werden und dich für ein Probetraining anmelden oder generell
            ein Teil der FIGHTBACK-Crew in Form von Ringrichter, Kameramann, Media-Team oder
            sonstigem werden?
          </DesktopBodyLarge>
          <DesktopBodyLarge>
            Dann melde dich gerne über unser Kontaktformular oder sende uns direkt eine E-Mail an{' '}
            <a className={styles.emailLink} href={'mailto:office@fightback-wrestling.com'}>
              office@fightback-wrestling.com
            </a>
          </DesktopBodyLarge>
        </div>
      </div>
      <div className={styles.wideColumn}>
        <ContactForm />
      </div>
    </div>
  )
}
